import React, { useState } from "react";
import "./login.css";
import logo from "../../assets/logo.png";
import google from "../../assets/google.png";
import login from "../../assets/login.webp";
import token from "../../assets/token.webp";
import clientCred from "../../assets/client-cred.webp";
import oauth from "../../assets/oauth.webp";
import { Button, Paper } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import InputIcon from "@mui/icons-material/Input";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import { maxWidth } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginSuccess } from "../../store/store";
import { foundryLogin } from "../../service/foundryService";
import UserTokenDialogBox from "../dialog-box/userTokenBox";
const SKYWISE_OAUTH = "https://core.skywise.com/foundry-multipass/api/oauth2";
const OAUTH_CLIENT_ID = "a19a27cf3a21656b6dfe2a6c1a3d24f7";
const OAUTH_FOUNDRY_REDIRECT_URI = "https://skywise.api.dev.2j17.aws.airbus-v.cloud/oauth_login/"
const Login = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  // const [userToken, setUserToken] = useState("");
  const isCognitoAuthenticated = useSelector(
    (state) => state.auth.isCognitoAuthenticated
  );
  const tokenLogin = () => {
    
    if (isCognitoAuthenticated) {
      setOpen(true);
      
    }else {
      return navigate("/cognito-login");
    }
  };
  const setBoxClose = () =>{
    setOpen(false)
}
const setBoxOpen = () => {
  setOpen(false)
}
  const oAuthLogin = () => {
    if (isCognitoAuthenticated) {
      window.location = window.location = `${SKYWISE_OAUTH}/authorize?client_id=${OAUTH_CLIENT_ID}&scope=offline_access+catalog:edit+compass:edit+lime:search-index+api:read-data+api:write-data+phonograph2:write-data+phonograph2:read-data+objects-gateway:read-data+objects-gateway:write-data&response_type=code&redirect_uri=${OAUTH_FOUNDRY_REDIRECT_URI}`
    }else {
      return navigate("/cognito-login");
    }
  };
  const clientCredientialsLogin = () => {
    if(isCognitoAuthenticated){
      handleM2MLogin()
    }else {
      return navigate("/cognito-login");
    }
      
  };
  const handleM2MLogin = async () => {
    try {
      let data = await foundryLogin();
      let token = data.access_token;
      let timeout = data.expires_in * 1000 + Date.now();
      let typeOfLogin = "M2M";
      dispatch(loginSuccess({ token, timeout, typeOfLogin }));
      return navigate("/home");
    } catch (error) {
      console.error("401-Unauthorized");
    }
  };
  return (
    // <div className="container center">
    //   <div className="login-container ">
    //     <div className="left">
    //       <img src={login} alt="" />
    //     </div>
    //     <div className="right">
    // <div className="sign-in-options">
    //   <div className="token login" onClick={tokenLogin}>
    //     <img src={token} alt="Token" />
    //     <label>Login using foundry token</label>
    //   </div>
    //         <hr width="100%" />
    // <div className="oauth login" onClick={oAuthLogin}  >
    //   <img src={oauth} alt="Token" />
    //   <label>Login with foundry user authentication</label>
    // </div>
    // <hr width="100%" />
    // <div className="client_cred login" onClick={clientCredientialsLogin}>
    //   <img src={clientCred} alt="Token" />
    //   <label>Login without foundry user authentication</label>
    // </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <React.Fragment>
    <UserTokenDialogBox 
       open = {open}
       setBoxClose = {setBoxClose}

    />
    <Grid container spacing={3}>
      <Grid item xs={12}></Grid>
      <Grid item mdOffset={2} md={8} xs={12}>
        <Paper elevation={24}>
          <Grid container spacing={2}>
            <Grid item md={4}>
              <img src={login} alt="" />
            </Grid>
            <Grid
              item
              mdOffset={2}
              md={5}
              spacing={2}
              style={{ marginTop: "12%" }}
            >
              <Button
                variant="outlined"
                startIcon={<InputIcon />}
                onClick={tokenLogin}
                fullWidth
              >
                Login using foundry token
              </Button>
              <p />
              <Button
                onClick={oAuthLogin}
                variant="outlined"
                startIcon={<LockOpenIcon />}
                fullWidth
              >
                Login with foundry user authentication
              </Button>
              <p />
              <Button
                onClick={clientCredientialsLogin}
                variant="outlined"
                startIcon={<VpnKeyIcon />}
                fullWidth
              >
                Login without foundry user authentication
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
    </React.Fragment>
  );
};

export default Login;
